import type { ThemeManifest } from "../types";

export const manifest: ThemeManifest = {
  id: "b2c",
  displayName: "B2C — Consumer",
  description: "Friendly, warm palette for consumer-facing clients.",
  extends: "default",
};
